import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };

    const handleBooking = () => {
        if (!email) {
            setError('Please enter your email address.');
            return;
        }
        if (!validateEmail(email)) {
            setError('Please enter a valid email address.');
            return;
        }

        // Clear error and proceed (placeholder for actual submission)
        setError('');
        // Redirect to Calendly
        window.open('https://calendly.com/j-anandhkumar-07/30min?month=2026-01', '_blank');
        setEmail('');
    };

    return (
        <section className="bg-white pt-8 sm:pt-12 pb-6 sm:pb-8 lg:pb-12 px-2 sm:px-2 lg:px-4">
            <div className="bg-black text-white rounded-[24px] sm:rounded-[40px] px-4 sm:px-6 py-12 sm:py-16 md:p-28 relative overflow-hidden">
                <div className="relative z-10 flex flex-col md:flex-row justify-between gap-8 sm:gap-12 md:gap-24 mb-12 sm:mb-24">
                    <div className="space-y-4 sm:space-y-6 md:w-1/2">
                        <span className="text-gray-400 text-xs sm:text-sm tracking-wide">Talk to us.</span>
                        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-medium leading-tight tracking-tight">
                            We'll tell the truth -<br />
                            Whether it helps us or not
                        </h2>
                    </div>

                    <div className="md:w-1/2 space-y-6 sm:space-y-8 flex flex-col justify-between">
                        <div className="self-center md:self-end max-w-md w-full space-y-3 sm:space-y-4">
                            <p className="text-gray-400 text-xs sm:text-sm text-center md:text-right">A 30-minute conversation. Zero pressure. Clarity guaranteed</p>
                            <div className="relative group flex flex-col md:block" id="footer-consultation">
                                <input
                                    type="email"
                                    placeholder="Enter your email address"
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        if (error) setError('');
                                    }}
                                    className={`w-full bg-white text-gray-900 px-6 py-4 md:pr-[180px] rounded-lg focus:outline-none focus:ring-2 transition-all ${error ? 'focus:ring-red-500 border-red-500 ring-2 ring-red-500' : 'focus:ring-blue-500'}`}
                                />
                                <button
                                    onClick={handleBooking}
                                    className="w-full md:w-auto md:absolute md:top-2 md:right-2 md:bottom-2 mt-3 md:mt-0 bg-[#2563EB] hover:bg-blue-600 text-white px-6 py-4 md:py-0 rounded-md text-sm font-medium transition-colors"
                                >
                                    Book a Consultation
                                </button>
                            </div>
                            {error && (
                                <p className="text-red-500 text-sm text-center md:text-right mt-2 animate-pulse">
                                    {error}
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                {/* Divider with Stars */}
                <div className="relative z-10 flex items-center justify-center gap-3 sm:gap-4 py-8 sm:py-12 md:py-16">
                    <div className="h-[1px] bg-white/20 flex-1"></div>
                    <div className="flex gap-2 sm:gap-4">
                        {[1, 2, 3].map((star) => (
                            <div key={star} className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-white/10 flex items-center justify-center">
                                <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" /></svg>
                            </div>
                        ))}
                    </div>
                    <div className="h-[1px] bg-white/20 flex-1"></div>
                </div>

                {/* Bottom Footer */}
                <div className="relative z-10 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400 gap-6">
                    <div className="text-center md:text-left">
                        2026 © <span className="text-white font-bold">Zenruva.</span> All Rights Reserved.
                    </div>
                    <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs md:text-sm">
                        <Link to="/services" className="text-white font-medium hover:text-blue-400 transition-colors">Our Expertise</Link>
                        <a href="#" className="hover:text-white transition-colors">Terms and Condition</a>
                        <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
                        <a href="#" className="hover:text-white transition-colors">Disclaimer</a>
                    </div>
                </div>

                {/* Background Watermark */}
                <div className="absolute bottom-[-5%] left-1/2 transform -translate-x-1/2 w-full text-center pointer-events-none select-none overflow-hidden">
                    <h1 className="text-[14vw] md:text-[180px] lg:text-[240px] font-bold text-white/[0.03] leading-none tracking-tighter mix-blend-overlay">
                        ZENRUVA
                    </h1>
                </div>
            </div>
        </section>
    );
}
